import React from 'react';
import { Link } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';

const FeaturedSection = () => {
  const featuredContent = {
    hero: {
      title: "The Complete GCC Establishment Framework",
      description: "A practitioner's guide to Global Capability Center setup in India — strategy, entity formation, talent, and operational launch — drawn from the Bootminds team's GCC engagements since 2017.",
      image: "https://images.unsplash.com/photo-1551434678-e076c223a692?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80",
      author: {
        name: "Bootminds Team",
        role: "GCC Practice"
      },
      stats: {
        readTime: "45 min"
      }
    },
    trending: [
      {
        id: 1,
        title: "Q4 2024 GCC Market Intelligence Report",
        type: "Market Report",
        readTime: "15 min",
        trending: true
      },
      {
        id: 2,
        title: "Talent Acquisition Strategies for Indian GCCs",
        type: "Strategic Guide",
        readTime: "25 min",
        trending: true
      },
      {
        id: 3,
        title: "Regulatory Compliance Checklist 2024",
        type: "Checklist",
        readTime: "10 min",
        trending: true
      }
    ]
  };

  return (
    <div className="mb-12">
      {/* Hero Featured Content */}
      <div className="bg-gradient-to-r from-primary to-secondary rounded-2xl overflow-hidden mb-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 p-8 lg:p-12">
          <div className="text-primary-foreground">
            <div className="flex items-center mb-4">
              <span className="inline-flex items-center px-3 py-1 rounded-full text-sm font-medium bg-accent text-accent-foreground mr-3">
                <Icon name="Star" size={14} className="mr-1" />
                Featured Resource
              </span>
              <span className="text-sm opacity-80">Bootminds GCC Practice</span>
            </div>
            
            <h1 className="font-headline font-bold text-3xl lg:text-4xl mb-4">
              {featuredContent.hero.title}
            </h1>
            
            <p className="text-lg opacity-90 mb-6 leading-relaxed">
              {featuredContent.hero.description}
            </p>
            
            <div className="flex items-center space-x-6 mb-8">
              <div className="flex items-center">
                <Icon name="Clock" size={16} className="mr-2" />
                <span className="text-sm">{featuredContent.hero.stats.readTime} read</span>
              </div>
            </div>

            <div className="flex items-center justify-between">
              <div className="flex items-center">
                <div className="w-10 h-10 rounded-full bg-primary-foreground/20 flex items-center justify-center mr-3">
                  <Icon name="Users" size={18} />
                </div>
                <div>
                  <p className="font-medium">{featuredContent.hero.author.name}</p>
                  <p className="text-sm opacity-80">{featuredContent.hero.author.role}</p>
                </div>
              </div>
              
              <Link
                to="#"
                className="inline-flex items-center px-6 py-3 bg-accent text-accent-foreground rounded-lg hover:bg-accent/90 transition-colors duration-300 font-medium"
              >
                <Icon name="Eye" size={18} className="mr-2" />
                View Resource
              </Link>
            </div>
          </div>
          
          <div className="relative">
            <div className="aspect-[4/3] rounded-xl overflow-hidden">
              <Image
                src={featuredContent.hero.image}
                alt={featuredContent.hero.title}
                className="w-full h-full object-cover"
              />
            </div>
            <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent rounded-xl"></div>
          </div>
        </div>
      </div>

      {/* Trending Resources */}
      <div className="bg-card rounded-xl border border-border p-6">
        <div className="flex items-center justify-between mb-6">
          <div className="flex items-center">
            <Icon name="TrendingUp" size={24} className="text-primary mr-3" />
            <h2 className="font-headline font-semibold text-xl text-text-primary">
              Trending This Week
            </h2>
          </div>
          <Link
            to="#"
            className="text-primary hover:text-primary transition-colors duration-300 text-sm font-medium"
          >
            View All Trending
          </Link>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {featuredContent.trending.map((item) => (
            <div
              key={item.id}
              className="group p-4 rounded-lg border border-border hover:border-primary/20 hover:bg-muted/50 transition-all duration-300 cursor-pointer"
            >
              <div className="flex items-start justify-between mb-3">
                <span className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-primary/10 text-text-primary">
                  {item.type}
                </span>
                                  <Icon name="TrendingUp" size={16} className="text-success" />
              </div>
              
              <h3 className="font-medium text-text-primary group-hover:text-primary transition-colors duration-300 mb-2">
                {item.title}
              </h3>
              
              <div className="flex items-center justify-between text-sm text-text-secondary">
                <div className="flex items-center">
                  <Icon name="Clock" size={14} className="mr-1" />
                  {item.readTime}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default FeaturedSection;